// A location's place alert setting, `enter_or_exit` on the API: a bitmask of
// arrive (1) and leave (2). The Fleet app offers the same four choices; keep
// the wording in step with it.
export const placeAlertOptions = [
    {value: 0, title: 'None'},
    {value: 1, title: 'Arrive'},
    {value: 2, title: 'Leave'},
    {value: 3, title: 'Both'},
];

export const placeAlertLabel = (value) =>
    placeAlertOptions.find((o) => o.value === Number(value ?? 0))?.title ?? 'None';

export const placeAlertHint = (value) => {
    const v = Number(value ?? 0);
    if (!v) {
        return 'No alerts for this place.';
    }
    const what = v === 1 ? 'arrives at' : v === 2 ? 'leaves' : 'arrives at or leaves';

    return `Sends an Arrived/Left alert when a vehicle ${what} this place, to the alert group of that vehicle's monitoring configuration.`;
};
